<template>
  <v-row justify="center" no-gutters>
    <v-row no-gutters class="maxWidthScreen">
      <v-col>
        <v-row class="mt-8" no-gutters justify="center">
          <b class="primary--text checkout-h2 font-weight-bold">{{
            $t("preSale.title")
          }}</b>
        </v-row>
        <v-row
          :class="$vuetify.breakpoint.mdAndUp ? '' : 'px-6'"
          class="mt-4 accent--text"
          justify="center"
          no-gutters
        >
          {{ $t("preSale.text") }}
        </v-row>
        <v-row class="mt-6" justify="center" no-gutters>
          <v-text-field
            background-color="white"
            style="
              max-width: 270px;
              border-top-right-radius: 0;
              border-bottom-right-radius: 0;
            "
            outlined
            v-model="coupon"
            @keydown.enter="getProducts"
          ></v-text-field>
          <v-btn
            height="51"
            style="border-top-left-radius: 0; border-bottom-left-radius: 0"
            depressed
            color="primary"
            @click="getProducts"
            ><v-icon>mdi-check</v-icon></v-btn
          >
        </v-row>
      </v-col>
    </v-row>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      coupon: "",
    };
  },
  methods: {
    async getProducts() {
      await this.$store.commit("SET_COUPON_APPLIED", this.coupon);
      this.$emit("getProducts");
    },
  },
};
</script>
